import createVueApp from '@/common/createApp'

Styxie.Initializers.MlapSettingsCallRail = {
  show: async(props) => {
    const { default: CallRailSettings } = await import('@/vue_widgets/mlap/settings/call_rail/index.vue')
    createVueApp(CallRailSettings, { props })
  }
}
